import { render, staticRenderFns } from "./AllDevis.vue?vue&type=template&id=013568c6&scoped=true"
import script from "./AllDevis.vue?vue&type=script&lang=js"
export * from "./AllDevis.vue?vue&type=script&lang=js"
import style0 from "./AllDevis.vue?vue&type=style&index=0&id=013568c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013568c6",
  null
  
)

export default component.exports